import * as React from "react";
import { pickLiveOrPreliveId, prepareEmptyMarket, findFirstAvailableMarket } from "../../../../../../helpers";
import { renderMiniBetButtonsRegular } from "../RenderMethods";
export var renderMiniMarketsRegular = function (cardProps, buttonsHolderClass, componentPrefix) {
    var marketsInConfig = cardProps.sport.config.markets;
    var market = prepareMarket(cardProps.markets, marketsInConfig, cardProps.event.isLive);
    var emptyMarket = prepareEmptyMarket(cardProps, marketsInConfig[0].template, 0);
    return (React.createElement("div", { key: componentPrefix + "__buttons-holder__" + cardProps.event.id, className: "rj-ev-list__" + componentPrefix + "__buttons-holder " + buttonsHolderClass, "data-uat": "div-ev-list-" + componentPrefix + "-buttons-holder" }, renderMiniBetButtonsRegular(cardProps, market || emptyMarket, componentPrefix)));
};
var prepareMarket = function (markets, marketsConfig, isLive) {
    var ids = marketsConfig.map(function (m) { return pickLiveOrPreliveId(m, isLive); });
    return findFirstAvailableMarket(markets, ids);
};
//# sourceMappingURL=renderMiniMarketsRegular.js.map